angular.module('DssMainApp').constant('DSSMainAppConstants', {

});